var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { boundMethod } from 'autobind-decorator';
import { v4 as uuid } from 'uuid';
import { ConditionOutcome, FlowNodeTypes, } from 'components/powerFlowShared/components/types';
import { formatPortsHelper } from 'components/powerFlowShared/helpers/nodePortFormatter';
import { FlowNode, flowNodeColor, NodeTypeComponent, } from 'fable/flowEditor';
import { Locations as ActionModal } from '../modals/locations';
const portTranslator = (node) => {
    const rules = node.payload.rules.map((rule) => ({
        connection: rule.match_node_id || uuid(),
        id: uuid(),
        label: rule.name,
        type: 'out',
    }));
    return [
        {
            connection: node.payload.non_match_node_id || uuid(),
            id: uuid(),
            label: ConditionOutcome.NO_MATCH,
            type: 'out',
        },
        ...rules,
    ];
};
export class LocationsNode extends NodeTypeComponent() {
    triggerEdit() {
        const { onEdit, node } = this.props;
        onEdit(node, node.nodeType);
    }
    render() {
        const { rules } = this.props.node.payload;
        return (_jsx(FlowNode, { color: LocationsNode.color, icon: LocationsNode.icon, label: LocationsNode.label, text: _jsxs("strong", { children: [rules.length, " ", rules.length === 1 ? 'location' : 'locations'] }), onEdit: this.triggerEdit }));
    }
}
LocationsNode.icon = 'world';
LocationsNode.label = 'Locations';
LocationsNode.helpText = 'Sort incoming calls based on country code. This is useful for general and specific locations (e.g. +44 for UK or +49035 for Dresden in Germany).';
LocationsNode.color = flowNodeColor.purple;
LocationsNode.translatePayload = formatPortsHelper(portTranslator);
LocationsNode.ActionModal = ActionModal;
LocationsNode.actionTrigger = { type: FlowNodeTypes.LOCATIONS };
LocationsNode.updateConnection = (node, port, newConnection) => {
    const payload = Object.assign({}, node.payload);
    if (port.connection === payload.non_match_node_id) {
        payload.non_match_node_id = newConnection;
    }
    else {
        const index = payload.rules.findIndex(({ match_node_id }) => port.connection === match_node_id);
        if (index >= 0) {
            payload.rules[index].match_node_id = newConnection;
        }
    }
    return Object.assign(Object.assign({}, node), { payload });
};
__decorate([
    boundMethod
], LocationsNode.prototype, "triggerEdit", null);
